import { Box, EmptyState } from '@chakra-ui/react'
import type { ReactNode } from 'react'

export function EmptyStateCard({
  icon,
  title,
  description,
  action,
  minH,
}: {
  icon: ReactNode
  title: ReactNode
  description?: ReactNode
  action?: ReactNode
  minH?: string
}) {
  return (
    <EmptyState.Root h="full" minH={minH}>
      <EmptyState.Content>
        <EmptyState.Indicator>{icon}</EmptyState.Indicator>
        <EmptyState.Title>{title}</EmptyState.Title>
        {description ? <EmptyState.Description>{description}</EmptyState.Description> : null}
        {action ? <Box w={{ base: 'full', md: 'auto' }}>{action}</Box> : null}
      </EmptyState.Content>
    </EmptyState.Root>
  )
}
